module.exports = __webpack_public_path__ + "img/wxNotice.75823c4f.png";